(() => {
  if (!window.customElements || customElements.get('mvp-benefit-carousel')) return;
  customElements.define('mvp-benefit-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.viewport = this.querySelector('[data-benefit-viewport]'); this.track = this.querySelector('[data-benefit-track]');
      if (!this.viewport || !this.track) return;
      this.abort = new AbortController(); const signal = this.abort.signal;
      this.cards = [...this.track.querySelectorAll(':scope > [data-benefit-slide]')]; this.index = 0;
      this.editor = this.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.editor && !this.motion.matches;
      this.inside = false; this.hovered = false; this.focused = false; this.holdUntil = 0;
      this.pauseButton = this.querySelector('[data-benefit-pause]'); this.dots = this.querySelector('[data-benefit-dots]');
      this.setAttribute('role','group'); this.setAttribute('aria-label','Beneficios de comprar en MVP');
      this.querySelector('[data-benefit-more]').hidden = !this.cards.length;
      this.querySelector('[data-benefit-controls]').hidden = this.cards.length < 2;
      this.dots.replaceChildren();
      this.cards.forEach((card,index) => {
        card.setAttribute('role','group'); card.setAttribute('aria-label',(index + 1)+' de '+this.cards.length);
        const button = document.createElement('button'); button.type='button';
        button.setAttribute('aria-label','Ver beneficio: '+(card.querySelector('h4')?.textContent.trim() || String(index+1)));
        button.addEventListener('click',()=>this.go(index),{signal}); this.dots.append(button);
      });
      this.querySelector('[data-benefit-prev]').addEventListener('click',()=>this.go(this.index-1),{signal});
      this.querySelector('[data-benefit-next]').addEventListener('click',()=>this.go(this.index+1),{signal});
      this.pauseButton.hidden = this.editor || this.motion.matches;
      this.pauseButton.addEventListener('click',()=>{this.running=!this.running;this.updateState();this.startTimer();},{signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.updateState();this.clearTimer();}},{signal});
      this.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'){this.hovered=false;this.updateState();this.startTimer();}},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.updateState();this.clearTimer();},{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>{if(!this.isConnected)return;this.focused=this.contains(document.activeElement);this.updateState();this.startTimer();}),{signal});
      this.viewport.addEventListener('pointerdown',()=>{this.holdUntil=Date.now()+8000;this.updateState();this.startTimer();},{signal,passive:true});
      this.viewport.addEventListener('scroll',()=>{
        clearTimeout(this.scrollTimer);
        this.scrollTimer=setTimeout(()=>{
          if(!this.isConnected)return;
          const origin=this.track.getBoundingClientRect().left;
          const offsets=this.cards.map(card=>card.getBoundingClientRect().left-origin);
          let closest=0;offsets.forEach((offset,i)=>{if(Math.abs(offset-this.viewport.scrollLeft)<Math.abs(offsets[closest]-this.viewport.scrollLeft))closest=i;});
          this.index=closest;this.updateState();this.startTimer();
        },100);
      },{signal,passive:true});
      this.addEventListener('shopify:block:select',event=>{
        if(!this.editor)return;
        const card=event.target.closest('[data-benefit-slide]'); const index=this.cards.indexOf(card);
        if(index>=0)this.go(index,false);
      },{signal});
      this.observer=new IntersectionObserver(entries=>{this.inside=entries[0].isIntersecting;this.updateState();this.startTimer();});this.observer.observe(this);
      this.resize=new ResizeObserver(()=>{
        if(this.resizeFrame)return;
        this.resizeFrame=requestAnimationFrame(()=>{this.resizeFrame=0;if(this.isConnected)this.go(this.index,false);});
      });this.resize.observe(this.viewport);
      this.motionChange=()=>{if(this.motion.matches)this.running=false;this.pauseButton.hidden=this.editor||this.motion.matches;this.updateState();this.startTimer();};
      this.motion.addEventListener('change',this.motionChange);
      document.addEventListener('visibilitychange',()=>{this.updateState();this.startTimer();},{signal});
      this.updateState(); this.startTimer();
    }
    go(index,smooth=true) {
      if(!this.cards.length)return;
      const next=(index%this.cards.length+this.cards.length)%this.cards.length;
      const wrapped=Math.abs(next-this.index)>1;this.index=next;
      const left=this.cards[next].getBoundingClientRect().left-this.track.getBoundingClientRect().left;
      this.viewport.scrollTo({left,behavior:smooth&&!wrapped&&!this.editor&&!this.motion.matches?'smooth':'instant'});
      this.updateState();this.startTimer();
    }
    updateState() {
      this.cards.forEach((card,i)=>card.classList.toggle('is-active',i===this.index));
      [...this.dots.children].forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));
      this.pauseButton.textContent=this.running?'Ⅱ':'▶';this.pauseButton.setAttribute('aria-label',this.running?'Pausar beneficios':'Reanudar beneficios');
      this.dataset.iconsRunning=String(this.dataset.iconMotion==='true'&&this.running&&this.inside&&!this.hovered&&!this.focused&&!this.editor&&!this.motion.matches&&!document.hidden&&Date.now()>=this.holdUntil);
    }
    clearTimer(){clearTimeout(this.timer);this.timer=0;}
    startTimer(){
      this.clearTimer();
      if(!this.running||this.editor||this.motion.matches||!this.inside||this.hovered||this.focused||document.hidden||this.cards.length<2)return;
      const delay=Math.max(3000,Math.min(10000,(Number(this.dataset.delay)||5)*1000),this.holdUntil-Date.now());
      this.timer=setTimeout(()=>{this.timer=0;if(this.isConnected)this.go(this.index+1);},delay);
    }
    disconnectedCallback(){
      this.abort?.abort();this.abort=null;this.clearTimer();clearTimeout(this.scrollTimer);cancelAnimationFrame(this.resizeFrame);this.resizeFrame=0;
      this.observer?.disconnect();this.resize?.disconnect();this.motion?.removeEventListener('change',this.motionChange);
      this.dataset.iconsRunning='false';
    }
  });
})();
